import axios from 'axios';
import { CAP_DOCS_ENDPOINT } from '../constants/endpoint';
// import capDocs from '../fixtures/capDocs';
import { getAuthToken } from '../providers/authTokenProvider';

export const GetCapDocs = async prospectId => {
  const config = {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  };
  try {
    const { response } = await axios.get(`${CAP_DOCS_ENDPOINT}/${prospectId}/docs`, config);
    return response;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
  // return capDocs;
};
